export const images = {
  hero: 'https://cdn.magicpatterns.com/patterns/generated-images/aad5c26b-b462-4834-aaaf-b2277cfa29e8.jpg',
  candidate:
    'https://cdn.magicpatterns.com/patterns/generated-images/08dd52e5-b028-4a5e-8ac3-1a2122f953ab.jpg',
  about: 'https://cdn.magicpatterns.com/patterns/generated-images/838a0570-660a-4ac4-b89d-d6451bc237c4.jpg',
  employers:
    'https://cdn.magicpatterns.com/patterns/generated-images/84c85af9-2013-4b9a-9747-92fc74fe6c33.jpg',
};

export const workingPrinciples = [
  {
    title: 'Role clarity first',
    body: 'Every search starts with a clear understanding of the role, the team, and what matters most to the organization.',
  },
  {
    title: 'Personal, professional outreach',
    body: 'Candidates are approached individually and respectfully, with an honest picture of the opportunity.',
  },
  {
    title: 'Respect for both sides',
    body: 'We aim to represent employers and professionals fairly, keeping communication clear and discreet.',
  },
];

export const employerBriefItems = [
  'Role title, reporting line, and team context',
  'Key responsibilities and the experience required',
  'Location, working arrangements, and timing',
  'Any confidentiality considerations',
];

export const candidateShareItems = [
  'Your current or most recent role',
  'The roles, functions, or sectors you would consider',
  'Preferred locations, or openness to relocation',
];

export const candidateSteps = [
  {
    title: 'Share your details',
    body: 'Register your interest with a short summary of your experience and the opportunities you would consider.',
  },
  {
    title: 'Review against relevant briefs',
    body: 'Your details are reviewed when a search aligns with your experience, location, and goals.',
  },
  {
    title: 'A confidential conversation',
    body: 'Where there is a potential fit, we contact you to discuss the opportunity before anything is shared.',
  },
];
